export default function (
    price: number | string,
    options: Intl.NumberFormatOptions = {}
): "Invalid format" | string {
    try {
        // Convert string to number if needed
        const numericPrice = typeof price === "string" ? parseFloat(price) : price;
        
        // Check if conversion resulted in a valid number
        if (isNaN(numericPrice)) {
            return "Invalid format";
        }
        
        return new Intl.NumberFormat("en-EN", {
            style: "currency",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            currency: "USD",
            ...options,
        }).format(numericPrice / 100);
    } catch (e) {
        return "Invalid format";
    }
}
